import { getSignupEnabled } from '@/api/auth'

/**
 * ¿Está abierta el alta pública de proveedores?
 *
 * El alta es por invitación: la emite un admin desde la consola y el proveedor
 * recibe un mail con el código y el link directo. El flag `provider_self_signup`
 * (Configurations → Feature Flags) permite reabrir el alta self-service sin
 * deploy, así que el portal no puede asumir la respuesta: la pregunta.
 *
 * La promesa se cachea a nivel de módulo: el guard de rutas la consulta en cada
 * navegación a /register y el login en cada montaje, y no tiene sentido pegarle
 * a la API cada vez. Se recarga sola al refrescar la página, que es cadencia de
 * sobra para un flag que cambia una vez por año.
 */
let cached: Promise<boolean> | null = null

export const isSignupEnabled = (): Promise<boolean> => {
  if (!cached) {
    cached = getSignupEnabled()
      .then(res => res.enabled)
      /*
       * Si la consulta falla, se asume alta CERRADA.
       *
       * Es el default seguro y además cubre la ventana de despliegue en la que
       * el portal ya salió y la API todavía no tiene el endpoint: preferimos
       * ofrecer "Request an account" de más que mandar a alguien a un alta que
       * la API va a rechazar con un 403.
       */
      .catch(() => false)
  }

  return cached
}

/** Solo para tests / reinicios manuales: descarta la respuesta cacheada. */
export const resetSignupEnabledCache = (): void => {
  cached = null
}
